import { render, staticRenderFns } from "./FormControlMBasketOrderitemsVariationId.vue?vue&type=template&id=2bef670e&scoped=true"
import script from "./FormControlMBasketOrderitemsVariationId.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlMBasketOrderitemsVariationId.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlMBasketOrderitemsVariationId.vue?vue&type=style&index=0&id=2bef670e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bef670e",
  null
  
)

export default component.exports